<template>
    <div>
  <v-row no-gutters>
      <v-col  cols="12" sm="3">
        <v-card
          class="full-height pt-0 pl-14 d-flex flex-column button-scarica"
          color="#FFFFFF00"
          elevation="0"
        >
          <v-btn
            class="button-download-main black--text "
            :class="attendi"
            tile
            block
            elevation="0"
            large
            color="#FFF"
            outlined
            @click="item1"
                 :disabled="scarica_button_active"
          >
            {{scarica}} 
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
    </div>
</template>
<script>
  import checkLanguage from "./../../classes/class_check_language";
export default {
  name: "scarica",
  props: ['item1', 'attendi'],
  data() {
    return {
      scarica:"SCARICA",
    };
    
  },
      mounted() {
    // controllo se inglese 
    this.i = new checkLanguage();
    if (!this.i.is_italian()){
      this.scarica = 'DOWNLOAD';
    }
  },
    computed: {
    button_download() {
      return this.$store.state.button_download;
    },
      scarica_button_active() {
      let result = true;
      let items = this.$store.state.items;
    for (const property in items) {
         if (items[property][0]['selected'] ) {
          result = false;
        }
    }
      return result;
    }
 
  },
}
</script>

<style scoped>
@media only screen  and (max-width: 1100px){
  .button-scarica{
  padding-left: 29px !important;
  padding-top:10px !important;
}


}
.attendi{
  pointer-events: none;
  opacity: 0.5;
  animation: glowing 1500ms infinite;
}

@keyframes glowing {
  0% { box-shadow: 0 0 -10px #dcdbd7; }
  40% { box-shadow: 0 0 20px #dcdbd7; }
  60% { box-shadow: 0 0 20px #dcdbd7; }
  100% { box-shadow: 0 0 -10px #dcdbd7; }
}
</style>